import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllDivisionsResponse, Division, substitutionsApi } from 'app/services/edpApiV1/substitutions';
import { RootState } from 'app/store';

type IDivisionsSlice = {
  data: Division[] | null;
  pagination: {
    size: number;
    page: number;
    total: number;
  };
};

const initialState: IDivisionsSlice = {
  data: null,
  pagination: {
    size: 10,
    page: 1,
    total: 0,
  },
};

export const divisionsSlice = createSlice({
  name: 'divisions',
  initialState,
  reducers: {
    toShowChangedDate: (state, { payload }: PayloadAction<string>) => {
      const newData = state.data?.reduce((acc: Division[], item: Division) => {
        if (item.id === payload) {
          return [
            ...acc,
            {
              ...item,
              substitution: { ...item.substitution, validToWasChangedBySupervisor: false },
            },
          ];
        }
        return [...acc, item] as Division[];
      }, []);
      return { ...state, data: newData || state.data };
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(
        substitutionsApi.endpoints.getAllDivisions.matchFulfilled,
        (state, { payload }: PayloadAction<GetAllDivisionsResponse>) => payload,
      )
      .addMatcher(substitutionsApi.endpoints.getAllDivisions.matchRejected, () => initialState);
  },
});

const divisions = (state: RootState) => state.entities.substitutions.divisions;
const getDivisions = createSelector(divisions, state => state);

export const selectors = { getDivisions };
export const actions = divisionsSlice.actions;
export const reducer = divisionsSlice.reducer;
